import React from 'react'
import ProductListingCard from './ProductListingCard'
import EKGLoader from '../Widgets/EKGLoader/EKGLoader'
import '../FacetSidebar/listing.scss'
import './listing.scss'

const { PUBLIC_URL } = process.env

function ProductListingGrid({
  searchTerm,
  products,
  isPriceVisible,
  isAuthenticated,
  isLoading,
  queryID,
  validateRxAndAddToCartFromParent,
}) {
  return (
    <div className="listing__main">
      <div className="listing__products">
        {products ? (
          products.map((product, index) => (
            <ProductListingCard
              product={product}
              isPriceVisible={isPriceVisible}
              isAuthenticated={isAuthenticated}
              searchTerm={searchTerm}
              queryID={queryID}
              key={product.id}
              plpIndex={index}
              validateRxAndAddToCartFromParent={validateRxAndAddToCartFromParent}
            />
          ))
        ) : (
          <div></div>
        )}
      </div>
    </div>
  )
}

export default ProductListingGrid
